var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white",
    stroke: "url(#paint0_linear_8771_82485)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8771_82485",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) calc(h - 42) calc(s - 59) calc(l + 27))"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioActiveIcon);
export default __webpack_public_path__ + "static/media/radio-active-icon.c5337a511f5bbb31b54b2ef50948dd42.svg";
export { ForwardRef as ReactComponent };